<template>
  <div>
    <TitleSlot title="商品推荐" :showMore="true"></TitleSlot>
    <div class="wrapper">
      <ul class="l" v-if="params.imgs.length>0">
        
        <li v-for="(item,index) in params.imgs" :key="index" :class="params.imgs.length == 1 ? 'one' : 'two' ">
          <a href="javascript:;" @click="itemClick(item)">
            <img :src="item.image" alt>
          </a>
        </li>
      </ul>
      <div class="r">
        <LoftRow :row="params.imgs.length==0?'':'row-4'" :list="params.list" :nums="nums"></LoftRow>
      </div>
    </div>
  </div>
</template>

<script>
import TitleSlot from "@/components/home/TitleSlot.vue";
import LoftRow from "./LoftRow.vue";
import {linkCommon } from '@/utils/index.js'

export default {
  name: "ProductLoft",
  components: { TitleSlot, LoftRow },
  props: {
    headTitle: {
      type: String,
      default: ""
    },
    params: {
        type: [Object, Array]
    },
    list: {
      type: Array,
      default: function() {
        return [];
      }
    },
    advLeft: {
      type: Array,
      default: function() {
        return [];
      }
    },
    keyword: {
      type: String,
      default: ""
    },
    nums: {
      type: [Number, String],
      default: -1
    }
  },
  computed: {
    slotArr() {
      return this.keyword.split(" ");
    }
  },
  data() {
    return {};
  },
  methods: {
    itemClick(v) {
      linkCommon(v, this)
    },
  }
};
</script>
<style lang="scss" scoped>
@import "~@/assets/css/variable.scss";
.wrapper {
  display: flex;
  justify-content: space-between;
  align-content: space-between;
  height: 628px;
  overflow: hidden;
  background: #f5f5f5;
  .l {
    width: 234px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    margin-bottom: 14px;
    margin-right: 14px;
    li {
      &.one {
        height: 100%;
      }
      &.two {
        height: 300px;
      }
      a {
        display: block;
        width: 234px;
        height: 100%;
        transition: all 0.25s;
        &:hover {
          transform: translateY(-3px);
          box-shadow: 1px 1px 20px #999;
        }
        img {
          display: block;
          width: 100%;
          height: 100%;
          object-fit: cover;
        }
      }
    }
  }
  .r {
    flex: 1;
    overflow: hidden;
  }
}
</style>